<template>
 <div class='bigDataMain'><br/>
     	 <Form ref="formValidate" :model="formValidate"  :label-width="110" >
	   <Row>
            <Col  span="6" offset="5">
                  <FormItem label="开始时间" prop="startTime" :class="{requireStar:true}">
                    <DatePicker type="date" placeholder="请选择开始时间" format="yyyy-MM-dd"
                    v-model="formValidate.startTime"  @on-change="formValidate.startTime=$event"
                    ></DatePicker>
                </FormItem>
            </Col>
			 <Col  span="6" >
                  <FormItem label="结束时间" prop="endTime" :class="{requireStar:true}">
                    <DatePicker type="date" placeholder="请选择结束时间" format="yyyy-MM-dd"
                    v-model="formValidate.endTime"  @on-change="formValidate.endTime=$event"
                    ></DatePicker>
                </FormItem>
            </Col>
			  <Button type="info"  @click="queryBtn" >查询</Button>
        </Row>
       
	</form> 
      <Row> 
            <Col span="4">&nbsp;</Col>
            <Col span="18"> <div id="myGl" style=" height: 600px;"></div></Col>
              
            <Col span="4"></Col>
      </Row>
 </div>
</template>

<script>
import echarts from 'echarts'
import date from '@/utils/date.js'
export default {
    data() {
        return {
            cityList : [],
            readList : [],
            dom: '',
            flag:true,
            list:[],
            formValidate: {
				 startTime: date.computedDate(new Date(new Date().setDate(new Date().getDate()-7)).toLocaleDateString()),
                 endTime: date.computedDate(new Date(new Date().setDate(new Date().getDate())).toLocaleDateString()),
            },
        }
    },
    methods: {
        
         queryBtn(){
               
                this.initTask()
            },
        ininMap(){
              
			  let timeList = []
			  let dataList =''
         if(this.cityList.length>0){
                   for (let i = 0; i < this.cityList.length; i++) {
                        const ele =  this.cityList[i];
                        timeList.push(ele.dateTimeList)
                        dataList = JSON.parse(JSON.stringify(this.cityList[i].dataList) );   
                    }
         
			let  seriesData=[];
			let  nameList=[];
            for(let i = 0; i < dataList.length; i++){
                  nameList.push(dataList[i].name)
                  seriesData.push({
                        'name':dataList[i].name,
                        'type':'bar',
                        'data':dataList[i].count,
                         'stack':'使用情况',
                          'barWidth': '30%'
                        });         
                    
            }


             var myGl = this.$echarts.init(this.dom);
          let    option = {
            title: {
                text: '查询数量统计',
                left:'center',
                textStyle: {    
                color: "#000",
                fontSize: 20,   
                }
            },
            tooltip: {
                 trigger: "axis",  
            },
            legend: {
                orient:"horizontal",
                x:'right',
                y:'top',
                width:'150',
                padding:[5, -50,0 ,0],
                itemWidth:30,
                data:nameList,//['同程(APP)','微信公众号(wechat)','携程(网站)','淘宝(APP)','花椒旅游(APP)','飞猪(APP)','飞猪(网站)','马蜂窝(网站)','驴妈妈(网站)'],
            },
            xAxis: {
                data: timeList[0],//["8月1日","8月2日","8月3日","8月4日","8月5日","8月6日","8月7日","8月8日","8月9日","8月10日"],
                splitLine:{
                    show:false,
                },
            },
            yAxis: {
                 splitLine:{
                    show:false,
                },
            },
             series : seriesData
          /**  series: [{
                name: '同程(APP)',
                type: 'bar',
                stack:'使用情况',
                data: [5, 20, 36, 10, 10, 20,10,20,8,12,15],
                barWidth: '30%',
                itemStyle:{
                     normal:{color:"#8CB9E2"},
                }
            },{
                name: '飞猪',
                type: 'bar',
                stack:'使用情况',
                data: [40, 22, 18, 35, 42, 40,30,18,12,25],
                barWidth: '30%',
                itemStyle:{
                     normal:{color:"#F2A46E"},
                }
            },{
                name: '淘宝',
                type: 'bar',
                stack:'使用情况',
                barWidth: '30%',
                data: [40, 22, 18, 35, 42, 40,23,9,22,10],
                itemStyle:{
                     normal:{color:"#C0C0C0"},
                }
            }]**/
        };
            
          
            if (option && typeof option === "object") {
                myGl.setOption(option, true);
                //myGl.setSeries(seriesData);
            } 
		 }
         
           
      },
      //查询数据
      initTask(){
		    this.cityList=[]
            let start = new Date(this.formValidate.startTime).getTime()
            let end = new Date(this.formValidate.endTime).getTime()
            if(start > end){
                this.$Message.error('结束时间不能小于开始时间');
                return
            } 
            let url = `/api/statistic?type=2&startDate=${this.formValidate.startTime}&endDate=${this.formValidate.endTime}`
            this.req({
                url: url,
                method: 'get'
            }).then(resp => {
               
                  this.cityList=resp.data.page
                  this.ininMap()
            }).catch(error => {
                this.$Message.error('服务器错误:' + error)
            })

			
        },

    },
    mounted() {
        var dom = document.getElementById("myGl");
        this.dom =dom;
        this.initTask()
        
    },
}
</script>
<style lang='less' scoped>
    .bigDataMain{
        width: 100%;
        height: 100%;
         background:#F3F3F3;
        #myGl{
              margin-top: 5px;
              margin-bottom: 30px;;
          }
    }
   
</style>



// WEBPACK FOOTER //
// src/pages/platform/statistics/queryNumSta.vue